<template>
  <q-dialog v-model="changePassword">
    <q-card>
      <q-form @submit="change">
        <div class="q-pa-lg">
          <div class="row q-col-gutter-xs">
            <div class="col-md-12 col-xs-12 col-lg-12 col-xl-12">
              <span class="label-input">Old Password*</span>
              <q-input
                ref="password"
                outlined
                :loading="loading"
                placeholder="***********"
                type="password"
                color="grey-7"
                :rules="[val => !!val || 'Please type your old password']"
                label-color="grey-7"
                lazy-rules
                v-model="password.old_password"
              >
                <template v-slot:prepend>
                  <q-icon name="fas fa-lock" size="16px" color="grey-7"></q-icon>
                </template>
              </q-input>
            </div>
            <div class="col-md-12 col-xs-12 col-lg-12 col-xl-12">
              <span class="label-input">New Password*</span>
              <q-input
                ref="password"
                outlined
                :loading="loading"
                placeholder="***********"
                type="password"
                color="grey-7"
                :rules="[passwordValid, comparePassword]"
                label-color="grey-7"
                lazy-rules
                v-model="password.new_password"
              >
                <template v-slot:prepend>
                  <q-icon name="fas fa-lock" size="16px" color="grey-7"></q-icon>
                </template>
              </q-input>
            </div>
            <div class="col-md-12 col-xs-12 col-lg-12 col-xl-12">
              <span class="label-input">New Password Confirmation*</span>
              <q-input
                ref="repassword"
                outlined
                :loading="loading"
                type="password"
                v-model="password.new_password_confirmation"
                placeholder="***********"
                color="grey-7"
                lazy-rules
                label-color="grey-7"
                :rules="[passwordValid]"
              >
                <template v-slot:prepend>
                  <q-icon name="fas fa-lock" size="16px" color="grey-7"></q-icon>
                </template>
              </q-input>
            </div>
            <div class="mt-5 flex-end q-gutter-xs">
              <q-btn @click="reset" color="grey-7" label="Cancel"></q-btn>
              <q-btn :loading="loading" label="Save" type="submit" color="positive">
                <template v-slot:loading>
                  <q-spinner-facebook />
                </template>
              </q-btn>
            </div>
          </div>
        </div>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import passwordValid from '../helper/passwordValidation'
import axios from '../axios/index'
export default {
  data() {
    return {
      loading: false,
      password: {
        old_password: '',
        new_password: '',
        new_password_confirmation: ''
      }
    }
  },
  methods: {
    comparePassword() {
      if (
        this.password.new_password &&
        this.password.new_password_confirmation &&
        this.password.new_password !== this.password.new_password_confirmation
      ) {
        return 'This field confirmation does not match.'
      }
    },
    passwordValid,
    async change() {
      try {
        this.loading = true
        const body = { ...this.password }
        const { data } = await axios.patch('password', body)
        this.$q.notify({
          message: data.message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
        this.changePassword = true
      } catch (error) {
        const { message } = error.response.data
        this.$q.notify({
          message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
      } finally {
        this.loading = false
      }
    },
    reset() {
      this.changePassword = false
      this.password = {
        first: '',
        second: ''
      }
    }
  },
  computed: {
    changePassword: {
      get() {
        return this.$store.state.profile.changePassword
      },
      set(val) {
        this.$store.commit('profile/SET_CHANGE_PASSWORD', val)
      }
    }
  },
  watch: {
    password: {
      deep: true,
      handler(n, o) {
        if (n.first == n.second) {
          this.$refs.password.resetValidation()
        }
      }
    }
  }
}
</script>
